import dayjs from 'dayjs';


export function activeClass(yn : string) {
    return yn === 'Y' ? 'table-7day' : 'table-60plus';
}

export function currencyRankingClass(d : string) {
    const daysAgo = dayjs().diff(d, 'day');

    if (daysAgo <= 7) {
        return 'table-7day';
    }

    if (daysAgo <= 30) {
        return 'table-30day';
    }

    if (daysAgo < 60) {
        return 'table-60day';
    }

    return 'table-60plus';
}


/**
 * Get some JSON-encoded data stored in a DOM element with a given ID,
 * typically a <script type="application/json">
 * and remove the element when done.
 *
 * @param id The id of the element holding the JSON data
 * @returns The decoded data, or undefined if the element wasn't found
 */
export function getScriptData(id: string): unknown {
    const elem = document.querySelector(`#${id}`);
    if (elem !== null && elem.textContent !== null && elem.textContent !== '') {
        const data: unknown = JSON.parse(elem.textContent);
        elem.remove();
        return data;
    }

    return undefined;
}
